export const getDisplayErrorString = (submitErrorMessage: string): string[] => {
	try {
		// Error in json:
		// "{\"errorMessages\":[],\"errors\":{\"assignee\":\"The default assignee does NOT have ASSIGNABLE permission OR Unassigned issues are turned off.\",\"othererror\":\"xxxx.\"}}";
		const errsObj = JSON.parse(submitErrorMessage);
		if (errsObj.errors) {
			const values: string[] = Object.values(errsObj.errors).filter(
				(value): value is string => typeof value === 'string',
			);
			if (values.length > 0) {
				return values;
			}
		}
	} catch (error) {
		/* empty */
	}
	return [submitErrorMessage];
};
